import podBackground from 'assets/img/product-details/pod/bg_header_pod_b.svg'
import tudoBackground from 'assets/img/product-details/tudo/bg_header_tudo_b.svg'
import { Tudo, PodTiffany, Pod } from 'assets/img/cards'

import { aleloTudoGroups } from './alelo-tudo-groups'
import { aleloPodGroups } from './pod-groups'
import { colors } from 'styles/colors'

export const tudoDetail = {
    id: 900,
    code: '900',
    type: 'TUDO',
    name: 'Alelo Tudo',
    title: 'Único, prático e a sua cara',
    subtitle:
        'É a solução completa, modular e adaptável para todas as necessidades.',
    image: Tudo,
    backgroundColor: colors.deepTeal,
    background: tudoBackground,
    labelColor: colors.lime,
    errorColor: colors.lime3,
    buttonBgColor: colors.lime,
    buttonColor: colors.deepTeal,
    gradient: `linear-gradient(85.09deg, #FFFF78 0.83%, #7AC943 58.74%)`,
    groups: aleloTudoGroups,
    colorAccent: colors.lime,
    backgroundFormColor: colors.darkGreen,
    patSwBackgroundColor: colors.deepTeal,
    patSwColorAccent: colors.swampGreen,
    patColor: colors.deepTeal
}

export const podDetail = {
    id: 700,
    code: '700',
    type: 'POD',
    name: 'Alelo POD',
    title: 'Benefícios flexíveis da Alelo rede Elo',
    subtitle: 'Aceito em milhões de estabelecimentos no Brasil.',
    image: Pod,
    tiffanyImage: PodTiffany,
    backgroundColor: colors.deepPurple,
    background: podBackground,
    labelColor: colors.emeraldGreen,
    errorColor: colors.vividOrange,
    buttonBgColor: colors.emeraldGreen,
    buttonColor: colors.deepPurple,
    gradient: `linear-gradient(85.09deg, #3DDDBC 0.83%, #914CEB 58.74%)`,
    groups: aleloPodGroups,
    colorAccent: colors.emeraldGreen,
    backgroundFormColor: colors.bgPurplePod,
    patSwBackgroundColor: colors.royalPurple,
    patSwColorAccent: colors.emeraldGreen,
    patColor: colors.deepPurple
}
